import React, { useState } from 'react'
import { PageTitle } from 'context/PageTitleContext'
import SwmsStore from './SwmsStore'
import SwmsAssignment from './SwmsAssignment'
import SwmsHowItWorks from './SwmsHowItWorks'
import './SwmsManagement.scss'

const TABS = [
    { value: 'store', label: 'SWMS Store' },
    { value: 'assignment', label: 'SWMS Assignment' },
    { value: 'how', label: 'How it works' },
]

export default function SwmsManagement() {
    const [tab, setTab] = useState('store')

    return (
        <div className="swms-management-root">
            <PageTitle title="SWMS Management" />
            <div className="sm-page-heading">
                <h2>SWMS Management</h2>
                <div className="sm-nav-tabs">
                    {TABS.map((t) => (
                        <button
                            key={t.value}
                            className={`sm-nav-tab${tab === t.value ? ' active' : ''}`}
                            onClick={() => setTab(t.value)}
                        >
                            {t.label}
                        </button>
                    ))}
                </div>
            </div>
            {tab === 'store' && <SwmsStore />}
            {tab === 'assignment' && <SwmsAssignment />}
            {tab === 'how' && <SwmsHowItWorks />}
        </div>
    )
}
